import styled from 'styled-components';

export const TopNavDiv = styled.div`
    position: relative;
`;

export const TopNavActions = styled.div`
    display: flex;
    width: 100%;
    height: 50px;
    background-color: ${({ theme }) => theme.colors.white};
    user-select: none;
`;

export const TopNavDivider = styled.div`
    width: 100%;
    height: 1px;
    background-color: lightgray;
    bottom: 0px;
    left: 0px;
`;
